import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';
import type { AfectacionTributaria, AfectacionTributariaInput } from '../../modelos/Configuracion';

export const afectacionTributariaService = {
  getAll: (empresaId: string): Promise<ApiResponse<AfectacionTributaria[]>> => {
    return httpClient.get('/afectacion-tributarias', { empresaId });
  },

  getById: (id: string): Promise<ApiResponse<AfectacionTributaria>> => {
    return httpClient.get(`/afectacion-tributarias/${id}`);
  },

  create: (data: AfectacionTributariaInput): Promise<ApiResponse<AfectacionTributaria>> => {
    return httpClient.post('/afectacion-tributarias', data);
  },

  update: (id: string, data: AfectacionTributariaInput): Promise<ApiResponse<AfectacionTributaria>> => {
    return httpClient.put(`/afectacion-tributarias/${id}`, data);
  },

  delete: (id: string): Promise<ApiResponse<void>> => {
    return httpClient.delete(`/afectacion-tributarias/${id}`);
  },

  setDefecto: (id: string, empresaId: string): Promise<ApiResponse<boolean>> => {
    return httpClient.post(`/afectacion-tributarias/${id}/defecto`, { empresaId });
  },

  toggleVisible: async (id: string, empresaId: string, esVisible: boolean): Promise<ApiResponse<AfectacionTributaria>> => {
    const current = await afectacionTributariaService.getById(id);
    if (!current.data) throw new Error('Afectación tributaria no encontrada');
    
    return httpClient.put(`/afectacion-tributarias/${id}`, {
      empresaId,
      codigo: current.data.codigo,
      codigoTributo: current.data.codigoTributo,
      impuesto: current.data.impuesto,
      nombre: current.data.nombre,
      alias: current.data.alias,
      esVisible,
      esDefecto: current.data.esDefecto,
    });
  },

  createMany: (data: AfectacionTributariaInput[]): Promise<ApiResponse<AfectacionTributaria[]>> => {
    return httpClient.post('/afectacion-tributarias/batch', data);
  },
};
